export const forms = {
  getFormData(formData, extend) {
    const data = [
      {
        type: 'input',
        label: '公告名称',
        col: '10',
        id: 'report_message_name',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'select',
        label: '公告类型',
        options: [
          {
            label: '内部公告',
            value: '内部公告'
          },
          {
            label: '政府公告',
            value: '政府公告'
          }
        ],
        col: '10',
        id: 'report_message_type',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'children',
        name: 'button',
        col: '4'
      }
    ]
    return data
  }
}
